import React from 'react'

function PartyOptIn({ onToggle, optedIn, eventName }) {
  return (
    <div
      onClick={onToggle}
    >
    <label
      htmlFor="opt-in"
      className="checkbox"
      data-testid="opt-in-check-label"
    >
      <input
        type="checkbox"
        checked={optedIn}
        id="opt-in"
        readOnly
      />
      My entire party is attending the {eventName}
    </label>
    </div>
  )
}

export default PartyOptIn
